import { render, staticRenderFns } from "./AdviserResources.vue?vue&type=template&id=ca0f422c&scoped=true"
import script from "./AdviserResources.vue?vue&type=script&lang=js"
export * from "./AdviserResources.vue?vue&type=script&lang=js"
import style0 from "./AdviserResources.vue?vue&type=style&index=0&id=ca0f422c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f422c",
  null
  
)

export default component.exports